import { motion, easeOut } from 'framer-motion';
import React from 'react';

interface Props {
	children?: React.ReactNode;
}

const MOTION_VARIANTS = {
	initial: ({ direction }: { direction: 'forward' | 'backward' }) => ({
		y: direction === 'backward' ? '-10px' : '10px',
		opacity: 0,
		transition: {
			type: 'spring',
			duration: 0.5,
			delay: 0,
			easeOut,
		},
	}),
	in: {
		y: 0,
		opacity: 1,
		transition: {
			type: 'spring',
			duration: 0.5,
			delay: 0,
			easeOut,
		},
	},
	out: ({ direction }: { direction: 'forward' | 'backward' }) => ({
		y: direction === 'backward' ? '10px' : '-10px',
		opacity: 0,
		transition: {
			type: 'spring',
			duration: 0.5,
			delay: 0,
			easeOut,
		},
	}),
};

const AnimateView = ({ children }: Props) => (
	<motion.div custom={{ direction: 'forward' }} initial="initial" animate="in" exit="out" variants={MOTION_VARIANTS}>
		{children}
	</motion.div>
);

export default AnimateView;
